module.exports = {
  IN: [],
  LK: ['chatbot', 'deliverontrain', 'irctc', 'irctcOrder', 'irctcStation', 'paytmForm', 'upiForm', 'worldPizzaLeague', 'worldPizzaLeagueApp'],
  BG: ['chatbot', 'deliverontrain', 'irctc', 'irctcOrder', 'irctcStation', 'paytmForm', 'upiForm', 'wallet', 'worldPizzaLeague', 'worldPizzaLeagueApp']
};
